import React from 'react'

function CustomOffCanvas({open,close,content}) {
  return (
    <div 
    className={`fixed inset-0 overflow-hidden z-50 transition-opacity duration-300 ${
      open ? 'opacity-100' : 'opacity-0 pointer-events-none'
    }`}
  >
    <div className="absolute inset-0 overflow-hidden">
      <div 
        className={`absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity duration-300 ${
          open ? 'opacity-100' : 'opacity-0'
        }`} 
        onClick={() => close()}
      />
      <section className="absolute inset-y-0 right-0 pl-10 max-w-full flex">
        <div 
          className={`w-screen max-w-md transform transition-transform duration-300 ease-in-out ${
            open ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <div className="h-full flex flex-col bg-white shadow-xl">
            <div className="flex-1 py-6 overflow-y-auto px-4 sm:px-6">
              <div className="flex items-start justify-between">
                <button
                  onClick={() => close()}
                  className="ml-3 h-7 flex items-center justify-center"
                >
                  <span className="sr-only">Close panel</span>
                  <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <div className="mt-8">
                {/* Add user form would go here */}
                {content}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
  )
}

export default CustomOffCanvas